import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import { formatDateShort } from "@/pages/deals/components/commercials/DealCommercialsV2/ContractTermsV2/consts";
import { findPendingVersion } from "./pendingVersion";
import { TermsVersionSummary } from "./types";

interface Props {
  versions: TermsVersionSummary[] | undefined;
}

// States that the terms on screen are scheduled to be replaced. True whichever
// way the open question about editing while an amendment is pending is settled:
// this describes what promotion does on the effective date, not what the editor
// allows before it.
export const PendingAmendmentBadge: React.FC<Props> = ({ versions }) => {
  const { t } = useTranslation();
  const pending = findPendingVersion(versions);
  if (!pending) return null;

  return (
    <div
      className="bg-badges-natural rounded-md px-2 py-1 w-fit"
      data-test="terms-pending-amendment-badge"
    >
      <Text variant="smBody" className="text-natural">
        {t("contracts.termsHistory.pendingBadge", {
          // Non-null: findPendingVersion rejects a pending row without a date.
          date: formatDateShort(pending.effectiveDate!)
        })}
      </Text>
    </div>
  );
};
